module.exports = "0.37.1";



/*****************
 ** WEBPACK FOOTER
 ** ./~/autocomplete.js/version.js
 ** module id = 1288
 ** module chunks = 0
 **/